import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Al día 5 ya sentía menos presión en mi cintura. Al día 12 mi esposo me preguntó si había bajado de peso. No lo podía creer.',
  name: 'María G.',
  location: 'Texas'
}, {
  quote: 'Llevaba 3 años con ese cansancio de las 3 PM. Pensé que era normal. En la semana 2 del protocolo desapareció completamente.',
  name: 'Carmen L.',
  location: 'Florida'
}, {
  quote: 'Mi médico me dijo que tenía hígado graso y no me dio ningún plan. Este protocolo fue exactamente lo que necesitaba.',
  name: 'Alejandra R.',
  location: 'California'
}];
export function Testimonials() {
  return <SectionWrapper bgColor="cream" data-id="element-304">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark mb-6 leading-tight text-center" data-id="element-305">
        Lo Que Dicen Las Mujeres Que Ya Lo Probaron
      </h2>

      <div className="space-y-4" data-id="element-306">
        {testimonials.map((t, idx) => <div key={idx} className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-307">
            <div className="absolute top-6 right-6 text-gray-200 font-serif text-6xl leading-none" data-id="element-308">
              "
            </div>
            <div className="flex gap-1 mb-4 relative z-10" data-id="element-309">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-310" />)}
            </div>
            <p className="font-sans text-lg text-gray-800 italic mb-4 relative z-10" data-id="element-311">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-3" data-id="element-312">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold" data-id="element-313">
                {t.name.charAt(0)}
              </div>
              <div data-id="element-314">
                <p className="font-bold text-dark" data-id="element-315">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-316">{t.location}</p>
              </div>
            </div>
          </div>)}
      </div>
    </SectionWrapper>;
}